<template>
  <div class="menu-config-container">
    <el-card>
      <div slot="header" class="clearfix">
        <span style="font-weight: bold; font-size: 16px;">{{ pageTitle }}</span>
        <div style="float: right;">
          <el-button-group style="margin-right: 10px;">
            <el-button 
              size="small"
              icon="el-icon-arrow-down"
              @click="expandAll">
              全部展开
            </el-button>
            <el-button 
              size="small"
              icon="el-icon-arrow-up"
              @click="collapseAll">
              全部收缩
            </el-button>
          </el-button-group>
          <el-button 
            type="primary" 
            size="small"
            icon="el-icon-plus"
            @click="handleAdd(null)">
            新增一级菜单
          </el-button>
        </div>
      </div>

      <el-table
        ref="permissionTable"
        :data="permissionTree"
        row-key="id"
        border
        :default-expand-all="isExpandAll"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
        <el-table-column
          prop="permissionName"
          label="菜单名称"
          min-width="200">
          <template slot-scope="scope">
            <i :class="scope.row.icon" style="margin-right: 5px;" v-if="scope.row.icon"></i>
            {{ scope.row.permissionName }}
          </template>
        </el-table-column>
        <el-table-column
          prop="permissionKey"
          label="权限标识"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="permissionType"
          label="类型"
          width="100"
          align="center">
          <template slot-scope="scope">
            <el-tag size="small" :type="scope.row.permissionType === 1 ? 'success' : 'warning'">
              {{ scope.row.permissionType === 1 ? '菜单' : '按钮' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="path"
          label="路由路径"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="component"
          label="组件路径"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="sort"
          label="排序"
          width="150"
          align="center">
          <template slot-scope="scope">
            <el-button-group>
              <el-button 
                size="mini" 
                icon="el-icon-top"
                @click="handleMoveUp(scope.row)"
                :disabled="isFirstItem(scope.row)"
                title="上移">
              </el-button>
              <el-button 
                size="mini" 
                icon="el-icon-bottom"
                @click="handleMoveDown(scope.row)"
                :disabled="isLastItem(scope.row)"
                title="下移">
              </el-button>
            </el-button-group>
            <span style="margin-left: 8px;">{{ scope.row.sort }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          width="80"
          align="center">
          <template slot-scope="scope">
            <el-tag size="small" :type="scope.row.status === 0 ? 'success' : 'danger'">
              {{ scope.row.status === 0 ? '正常' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="300"
          align="center"
          fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.permissionType === 1"
              type="text"
              size="small"
              @click="handleAdd(scope.row)">
              <i class="el-icon-plus"></i> 添加
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="handleEdit(scope.row)">
              <i class="el-icon-edit"></i> 编辑
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="handleQuickSort(scope.row)">
              <i class="el-icon-sort"></i> 排序
            </el-button>
            <el-button
              type="text"
              size="small"
              style="color: #f56c6c;"
              @click="handleDelete(scope.row)">
              <i class="el-icon-delete"></i> 删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-click-modal="false"
      @close="resetForm">
      <el-form
        :model="formData"
        :rules="rules"
        ref="permissionForm"
        label-width="100px">
        <el-form-item label="权限名称" prop="permissionName">
          <el-input v-model="formData.permissionName" placeholder="请输入权限名称"></el-input>
        </el-form-item>
        <el-form-item label="权限标识" prop="permissionKey">
          <el-input v-model="formData.permissionKey" placeholder="例如: user:view, user:add"></el-input>
        </el-form-item>
        <el-form-item label="权限类型" prop="permissionType">
          <el-radio-group v-model="formData.permissionType">
            <el-radio :label="1">菜单</el-radio>
            <el-radio :label="2">按钮</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="上级菜单">
          <el-cascader
            v-model="formData.parentId"
            :options="menuOptions"
            :props="{ checkStrictly: true, value: 'id', label: 'permissionName', emitPath: false }"
            clearable
            placeholder="选择上级菜单（不选则为一级菜单）">
          </el-cascader>
        </el-form-item>
        <el-form-item label="路由地址" v-if="formData.permissionType === 1">
          <el-input v-model="formData.path" placeholder="例如: /user"></el-input>
        </el-form-item>
        <el-form-item label="组件路径" v-if="formData.permissionType === 1">
          <el-input v-model="formData.component" placeholder="例如: UserManage"></el-input>
        </el-form-item>
        <el-form-item label="菜单图标" v-if="formData.permissionType === 1">
          <el-input v-model="formData.icon" placeholder="例如: el-icon-user">
            <i slot="prefix" :class="formData.icon" v-if="formData.icon"></i>
          </el-input>
        </el-form-item>
        <el-form-item label="显示顺序" prop="sort">
          <el-input-number v-model="formData.sort" :min="0" :max="9999"></el-input-number>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="formData.status">
            <el-radio :label="0">正常</el-radio>
            <el-radio :label="1">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'MenuConfigNew',
  data() {
    return {
      pageTitle: '菜单配置管理', // 默认标题
      permissionTree: [],
      menuOptions: [],
      dialogVisible: false,
      dialogTitle: '',
      isExpandAll: true,
      formData: {
        id: null,
        permissionName: '',
        permissionKey: '',
        permissionType: 1,
        parentId: 0,
        path: '',
        component: '',
        icon: '',
        sort: 0,
        status: 0
      },
      rules: {
        permissionName: [
          { required: true, message: '请输入权限名称', trigger: 'blur' }
        ],
        permissionKey: [
          { required: true, message: '请输入权限标识', trigger: 'blur' }
        ],
        permissionType: [
          { required: true, message: '请选择权限类型', trigger: 'change' }
        ],
        sort: [
          { required: true, message: '请输入显示顺序', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.loadPageTitle()
    this.loadPermissionTree()
  },
  methods: {
    // 动态加载页面标题
    async loadPageTitle() {
      try {
        const menuData = localStorage.getItem('admin_menu_data')
        if (menuData) {
          const menus = JSON.parse(menuData)
          const allMenus = menus.menus || []
          const currentMenu = allMenus.find(m => m.url === this.$route.path)
          if (currentMenu) {
            this.pageTitle = currentMenu.name
          }
        }
      } catch (error) {
        console.error('加载页面标题失败:', error)
      }
    },
    // 加载权限树
    async loadPermissionTree() {
      try {
        const res = await this.$axios.get('/admin/permission/tree')
        if (res.data.code === 200) {
          console.log('🔍 原始后端数据:', res.data.data)
          
          // 递归转换status为数字类型
          const convertStatus = (items) => {
            return items.map(item => {
              console.log(`  项目: ${item.permissionName}, 原始status:`, item.status, typeof item.status)
              item.status = Number(item.status)
              console.log(`  转换后status:`, item.status, typeof item.status)
              if (item.children && item.children.length > 0) {
                item.children = convertStatus(item.children)
              }
              return item
            })
          }
          this.permissionTree = convertStatus(res.data.data || [])
          console.log('✅ 处理后的数据:', this.permissionTree)
          this.buildMenuOptions()
        } else {
          this.$message.error(res.data.message || '加载菜单失败')
        }
      } catch (error) {
        console.error('加载菜单失败:', error)
        this.$message.error('加载菜单失败')
      }
    },

    // 构建菜单选项（用于上级菜单选择）
    buildMenuOptions() {
      const filterMenuType = (items) => {
        return items
          .filter(item => item.permissionType === 1)
          .map(item => ({
            id: item.id,
            permissionName: item.permissionName,
            children: item.children ? filterMenuType(item.children) : []
          }))
      }
      this.menuOptions = filterMenuType(this.permissionTree)
    },

    // 新增
    handleAdd(row) {
      this.dialogTitle = row ? '新增子菜单' : '新增一级菜单'
      this.formData = {
        id: null,
        permissionName: '',
        permissionKey: '',
        permissionType: row ? (row.permissionType === 1 ? 1 : 2) : 1,
        parentId: row ? row.id : 0,
        path: '',
        component: '',
        icon: '',
        sort: 0,
        status: 0
      }
      this.dialogVisible = true
    },

    // 编辑
    handleEdit(row) {
      this.dialogTitle = '编辑菜单'
      this.formData = {
        id: row.id,
        permissionName: row.permissionName,
        permissionKey: row.permissionKey,
        permissionType: row.permissionType,
        parentId: row.parentId || 0,
        path: row.path || '',
        component: row.component || '',
        icon: row.icon || '',
        sort: row.sort,
        status: Number(row.status) // 确保是数字类型
      }
      this.dialogVisible = true
    },

    // 删除
    handleDelete(row) {
      this.$confirm('确定要删除该权限吗？删除后将无法恢复！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await this.$axios.delete(`/admin/permission/delete/${row.id}`)
          if (res.data.code === 200) {
            this.$message.success('删除成功')
            this.loadPermissionTree()
          } else {
            this.$message.error(res.data.message || '删除失败')
          }
        } catch (error) {
          console.error('删除失败:', error)
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    },

    // 提交表单
    submitForm() {
      this.$refs.permissionForm.validate(async (valid) => {
        if (valid) {
          try {
            const res = await this.$axios.post('/admin/permission/save', this.formData)
            if (res.data.code === 200) {
              this.$message.success(this.formData.id ? '更新成功' : '新增成功')
              this.dialogVisible = false
              this.loadPermissionTree()
            } else {
              this.$message.error(res.data.message || '保存失败')
            }
          } catch (error) {
            console.error('保存失败:', error)
            this.$message.error('保存失败')
          }
        }
      })
    },

    // 重置表单
    resetForm() {
      this.$refs.permissionForm && this.$refs.permissionForm.resetFields()
    },

    // 全部展开
    expandAll() {
      this.isExpandAll = true
      this.toggleExpand(this.permissionTree, true)
    },

    // 全部收缩
    collapseAll() {
      this.isExpandAll = false
      this.toggleExpand(this.permissionTree, false)
    },

    // 切换展开/收缩状态
    toggleExpand(data, isExpand) {
      data.forEach(item => {
        this.$refs.permissionTable.toggleRowExpansion(item, isExpand)
        if (item.children && item.children.length > 0) {
          this.toggleExpand(item.children, isExpand)
        }
      })
    },

    // 获取同级菜单列表
    getSiblings(item) {
      // 递归查找包含目标项的层级
      const findSiblings = (tree, targetId) => {
        // 如果在当前层级找到了目标项，返回当前层级
        const found = tree.find(node => node.id === targetId)
        if (found) {
          return tree
        }
        
        // 递归查找children
        for (let node of tree) {
          if (node.children && node.children.length > 0) {
            const result = findSiblings(node.children, targetId)
            if (result) return result
          }
        }
        
        return null
      }
      
      return findSiblings(this.permissionTree, item.id) || []
    },

    // 判断是否是第一项
    isFirstItem(item) {
      const siblings = this.getSiblings(item)
      return siblings.length === 0 || siblings[0].id === item.id
    },

    // 判断是否是最后一项
    isLastItem(item) {
      const siblings = this.getSiblings(item)
      return siblings.length === 0 || siblings[siblings.length - 1].id === item.id
    },

    // 上移
    async handleMoveUp(item) {
      try {
        const siblings = this.getSiblings(item)
        const currentIndex = siblings.findIndex(s => s.id === item.id)
        
        if (currentIndex <= 0) {
          this.$message.warning('已经是第一项，无法上移')
          return
        }
        
        const prevItem = siblings[currentIndex - 1]
        
        // 重新计算排序值：取上一项的sort值，然后将上一项+1
        const newSort = prevItem.sort
        const prevNewSort = prevItem.sort + 1
        
        await this.updateSort(item.id, newSort)
        await this.updateSort(prevItem.id, prevNewSort)
        
        this.$message.success('上移成功')
        await this.loadPermissionTree()
      } catch (error) {
        console.error('上移失败:', error)
        this.$message.error('上移失败：' + error.message)
      }
    },

    // 下移
    async handleMoveDown(item) {
      try {
        const siblings = this.getSiblings(item)
        const currentIndex = siblings.findIndex(s => s.id === item.id)
        
        if (currentIndex >= siblings.length - 1) {
          this.$message.warning('已经是最后一项，无法下移')
          return
        }
        
        const nextItem = siblings[currentIndex + 1]
        
        // 重新计算排序值：取下一项的sort值，然后将下一项-1
        const newSort = nextItem.sort
        const nextNewSort = nextItem.sort - 1
        
        await this.updateSort(item.id, newSort)
        await this.updateSort(nextItem.id, nextNewSort)
        
        this.$message.success('下移成功')
        await this.loadPermissionTree()
      } catch (error) {
        console.error('下移失败:', error)
        this.$message.error('下移失败：' + error.message)
      }
    },

    // 快速排序
    handleQuickSort(item) {
      this.$prompt('请输入新的排序值', '快速排序', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[0-9]+$/,
        inputErrorMessage: '请输入有效的数字',
        inputValue: item.sort.toString()
      }).then(async ({ value }) => {
        const newSort = parseInt(value)
        if (newSort === item.sort) {
          this.$message.info('排序值未改变')
          return
        }
        
        await this.updateSort(item.id, newSort)
        this.$message.success('排序更新成功')
        this.loadPermissionTree()
      }).catch(() => {})
    },

    // 更新排序
    async updateSort(id, sort) {
      const res = await this.$axios.post('/admin/permission/updateSort', [
        { id, sort }
      ])
      if (res.data.code !== 200) {
        throw new Error(res.data.message || '更新排序失败')
      }
      return res.data
    }
  }
}
</script>

<style scoped>
.menu-config-container {
  padding: 20px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>